import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerObjectClassSettingsRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-object-class-settings',
	path: '/jira/assets/data-manager/object-classes/:objectClassId/settings/:settingType(mapping-matrix|cleansing-statistics|data-dictionaries|default-attribute-mapping|attributes|data-source-priorities|attribute-priorities)',
	exact: true,
};
